import React, { useEffect, Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import { TVData } from "../../utils/types/app.types";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store.ts";
import { updateTvShows } from "../../store/slices/tvShows.slice.ts";
import { init } from "../../utils/GlobalFunctions/initialize.ts";
import PosterCard from "../../components/PosterCard/index.tsx";

const TvShowsContainer: React.FC = () => {
  const sessionData = useSelector((state: RootState) => state.session);
  const tvShows = useSelector((state: RootState) => state.tvshows);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    init(dispatch, sessionData, "tv/popular", tvShows, updateTvShows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <section className="container page-section">
        <h2 className="page-section-title">Popular TV Shows</h2>
        <div id="popular-shows" className="movie-grid">
          {tvShows.length > 0 &&
            tvShows.map((show: TVData) => (
              <PosterCard
                key={show.id}
                linkTo={`/tv-details/${show.id}`}
                title={show.name ?? show.title ?? ""}
                posterPath={show.poster_path}
                subtitle={`First air: ${show.first_air_date ?? "—"}`}
              />
            ))}
        </div>

        {location.pathname.includes("/shows") && (
          <div className="section-cta">
            <Link to="/genres/tv" className="btn-pill">
              Browse TV genres
            </Link>
          </div>
        )}
      </section>
    </Fragment>
  );
};

export default TvShowsContainer;
